var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio",class:{ 'disabled': _vm.disabled }},[_c('div',{class:{ 'radio__circle': _vm.type==='circle', 'radio__box': _vm.type==='box' }},[_c('input',{ref:"radio",attrs:{"id":_vm.id,"disabled":_vm.disabled,"name":_vm.name,"type":"radio"},domProps:{"checked":_vm.checked},on:{"input":_vm.updateCheck}}),_c('div',{class:{ 'radio-circle': _vm.type==='circle', 'radio-box': _vm.type==='box' }})]),(_vm.text)?_c('label',{style:({
                '--text-width': _vm.textWidth,
                '--font-size': _vm.fSize,
                '--font-color': _vm.fColor
                }),attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }